'use strict';

import template from '../../templates/timesheet/Layout.ejs';
import ListView from './List.js';
import moment from 'moment';

module.exports = Backbone.View.extend({
    events: {},

    initialize(options) {
        this.options = _.defaults(options || {}, {
            date: moment().startOf('week').toDate(),
            overtimeItems: [],
            unsubmittedPayroll: null
        });
        this.listView = new ListView({
            collection: this.collection,
            date: this.options.date,
            overtimeItems: this.options.overtimeItems,
            unsubmittedPayroll: this.options.unsubmittedPayroll
        });
        return this.render();
    },

    render() {
        const weekStart = moment(this.options.date).startOf('week');
        const weekEnd = moment(this.options.date).endOf('week');
        const week =
            `${weekStart.format('DD')} - ${weekEnd.format('DD MMM YYYY')}`;
        this.$el.html(template({
            week: week,
            prevWeek: moment(this.options.date)
                .add(-1, 'week').format('DD-MM-YYYY'),
            nextWeek: moment(this.options.date)
                .add(1, 'week').format('DD-MM-YYYY')
        }));
        this.$('.js-content').append(this.listView.$el);
        return this;
    },

    remove() {
        this.listView.remove();
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/timesheet/Layout.js